import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Lock, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin-login", { password });
      loginWithToken(data.token, data.user);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center text-sm text-muted-foreground hover:text-white mb-10 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back home
        </Link>
        <div className="flex flex-col items-center text-center mb-10">
          <div className="h-14 w-14 rounded-full border border-white/20 flex items-center justify-center mb-6">
            <Lock className="h-6 w-6 text-white" />
          </div>
          <span className="font-serif text-3xl text-white">Admin Access</span>
          <p className="text-[10px] tracking-luxe uppercase text-muted-foreground mt-2">Autobus Limo Mont Royal</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-luxe text-muted-foreground">Password</Label>
            <Input data-testid="admin-password" type="password" required autoFocus value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-12 bg-secondary border-white/10 text-white" placeholder="Enter admin password" />
          </div>
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full h-12 rounded-full bg-white text-black hover:bg-white/85">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Access Dashboard"}
          </Button>
        </form>
        <p className="text-xs text-muted-foreground mt-8 text-center leading-relaxed">
          This area is restricted. Enter the admin password to view the CRM dashboard.
        </p>
      </div>
    </div>
  );
}
